import {
  ScheduledLessonExamFilters,
  listScheduledLessonExams,
} from '@/data/services/scheduledLessonExamServices';

export const scheduledLessonExamQueries = {
  all: ['scheduledLessonExams'] as const,

  list: (filters: ScheduledLessonExamFilters = {}) => ({
    queryKey: [...scheduledLessonExamQueries.all, 'list', { filters }] as const,
    queryFn: () => listScheduledLessonExams(filters),
  }),

  listInfinite: (filters: ScheduledLessonExamFilters = {}) => ({
    queryKey: [
      ...scheduledLessonExamQueries.list(filters).queryKey,
      'infinite',
    ] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listScheduledLessonExams({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
